import axios from '@fs/zion-axios'
import type { AxiosPromise, Axios } from '@fs/zion-tree-types/zion-axios'

export function recommendMePerson(
  groupId: string,
  cisId: string,
  suggestedMePerson?: string | null
): AxiosPromise<unknown> {
  const body = { recommendedPersonId: suggestedMePerson }
  return (axios as Axios).post<unknown>(`/service/tree/tree-data/groups/${groupId}/members/by-id/${cisId}`, body)
}

/**
 * Sets personSharingAccepted value for a groupMember.
 * Set personSharingAccepted to true when the member has accepted the legal terms of use when joining a shared tree.
 * @param {string} groupId  - The groups Id
 * @param {string} cisId - The group members cis Id
 * @param {boolean} personSharingAccepted - The value personSharingAccepted will be set to.
 * @returns
 */
export function setPersonSharingAccepted(
  groupId: string,
  cisId: string,
  personSharingAccepted: boolean
): AxiosPromise<unknown> {
  if (!groupId || !cisId) throw new Error('Invalid groupId or group member cisId')
  return (axios as Axios).post<unknown>(`/service/tree/tree-data/groups/${groupId}/members/by-id/${cisId}`, {
    personSharingAccepted,
  })
}
